/**
 * Pure paging math for the in-game recent-events log's infinite scroll.
 * Kept out of the component so the "load the next page when you're N rows from
 * the bottom" rule is unit-testable.
 */

/** Rows loaded initially and per page in the spectator feed. */
export const EVENT_PAGE_SIZE = 40

/** Rough compact-row height (row + divider), for the scroll-distance threshold. */
export const COMPACT_ROW_ESTIMATE = 44

/** How many rows from the bottom triggers loading the next page. */
export const LOAD_MORE_ROW_THRESHOLD = 5

/**
 * Whether to reveal the next page: the viewer is within
 * LOAD_MORE_ROW_THRESHOLD rows of the bottom AND more rows exist beyond the
 * current window.
 */
export function shouldLoadMoreEvents(opts: {
  distanceFromBottomPx: number
  windowSize: number
  totalRows: number
}): boolean {
  if (opts.windowSize >= opts.totalRows) return false
  return opts.distanceFromBottomPx < LOAD_MORE_ROW_THRESHOLD * COMPACT_ROW_ESTIMATE
}

/** The next window size after a load-more, capped at the total row count. */
export function growEventWindow(windowSize: number, totalRows: number): number {
  return Math.min(windowSize + EVENT_PAGE_SIZE, totalRows)
}
